// extracted by mini-css-extract-plugin
export var integrationButton = "_b5-0";